import { ReadonlySignal, computed } from "@preact/signals-core";
import { IMenuItem, MenuItemType } from "dots-ui/dotsMenuBar";
import { useCallback, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AvisConstants } from "../../../../data/avisConstants";
import { getVerticalBarMenuItems } from "../../../../data/verticalBarMenuItems";
import { AuthorsUtils } from "../../../../utils";
import { AvisContext } from "../../context/AvisContext";
import { ForbiddenPage } from "../../error/ForbiddenPage";
import { Layout } from "./";
import { HorizontalMenuItems } from "./menuItems/HorizontalMenuItems";

export function LayoutAuthors() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    ctxRightsHolder,
    ctxRightsHolders,
    portalKind,
    logout,
    res,
    resetRightsHolder,
  } = useContext(AvisContext);

  const isAllowedRoute = useMemo(
    () => AuthorsUtils.isAllowedLocation(location, ctxRightsHolder),
    [location, ctxRightsHolder],
  );

  const getUrl = (url?: string) => {
    if (!url) return;

    if (url === `/${AvisConstants.url_part_portal_authors}`)
      return AuthorsUtils.getStartPagePath(ctxRightsHolder);

    const urlParams = AuthorsUtils.getUrlParams(ctxRightsHolder);
    return AuthorsUtils.getUrlWithParams(url, urlParams);
  };

  const mapMenuItems = useCallback(
    (data?: IMenuItem[]): IMenuItem[] | undefined => {
      if (!data) return;

      const result: IMenuItem[] = [];
      data.forEach((item) => {
        const url = getUrl(item.url);

        const isAllowed = AuthorsUtils.isAllowedRouteByUrl(
          url,
          ctxRightsHolder,
        );

        if (!item.title && !isAllowed) return;

        result.push({
          ...item,
          command: url ? () => navigate(url) : null,
          items: mapMenuItems(item.items),
          url: url,
        } as IMenuItem);
      });

      return result;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [navigate],
  );
  const mappedItems = useMemo(
    () => mapMenuItems(getVerticalBarMenuItems(location.pathname)),
    [location.pathname, mapMenuItems],
  );
  const verticalMenuItems: IMenuItem[] = useMemo(() => {
    const items = [];

    if (mappedItems) items.push(...mappedItems);

    return items;
  }, [mappedItems]);

  const horizontalMenuItems: ReadonlySignal<MenuItemType[]> = computed(() =>
    HorizontalMenuItems(
      verticalMenuItems,
      logout,
      navigate,
      res,
      portalKind,
      ctxRightsHolder,
      ctxRightsHolders,
      resetRightsHolder,
    ),
  );

  if (!isAllowedRoute && !!ctxRightsHolder) {
    return <ForbiddenPage showToHomePageButton />;
  }

  return (
    <Layout
      horizontalMenuItems={horizontalMenuItems.value}
      verticalMenuItems={verticalMenuItems}
    />
  );
}
